import React from 'react'
import { useTranslation } from 'react-i18next'

import { MyWorkTab } from '@/features/my-work'
import CompleteImage from '@/public/images/asset-1.svg'
import InProgressImage from '@/public/images/complete-1.svg'

interface EmptyMyWorkResultProps {
  translationKey: MyWorkTab
  showImage?: boolean
  className?: string
}

export const EmptyMyWorkResult: React.FC<EmptyMyWorkResultProps> = ({
  translationKey,
  showImage = true,
  className = '',
}) => {
  const { t } = useTranslation()

  const getEmptyImage = () => {
    switch (translationKey) {
      case 'inProgress':
        return InProgressImage
      case 'completed':
        return CompleteImage
      default:
        return InProgressImage
    }
  }
  return (
    <div className={className}>
      {showImage && (
        <img src={getEmptyImage()} alt="No results" className="mb-4" />
      )}
      <div className="flex flex-col space-y-2">
        <h3 className="p-0 m-0 font-semibold text-primary-900 text-lg">
          {t(`myWork.${translationKey}.empty.title`)}
        </h3>
        {t(`myWork.${translationKey}.subtitle`) && (
          <p className="p-0 m-0 text-sm text-gray-600">
            {t(`myWork.${translationKey}.empty.subtitle`)}
          </p>
        )}
      </div>
    </div>
  )
}
